import { combineEpics } from 'redux-observable';
import { tenantSelectionEpics } from '../tenantselection/ducks/epics';
import { userEpics } from '../users/ducks/epics';
import { branchSelectionEpics } from '../branchselection/epics';
import { riskAssessmentEpics } from '../riskAssessments/ducks/epics';
export default combineEpics(userEpics, tenantSelectionEpics as any, branchSelectionEpics as any, riskAssessmentEpics as any);
